const highlightStyles = {
    container: `flex flex-col gap-[14px] w-[90%] items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] max-w-[400px] bg-themeShadowColor overflow-hidden
        sm:min-w-[550px] sm:h-[300px] sm:rounded-[10px]
    `,
    fullScreenFile: `w-full h-full`,
}

export { highlightStyles }